import { render, staticRenderFns } from "./OtTable.vue?vue&type=template&id=ee7b3bcc&scoped=true&lang=pug"
import script from "./OtTable.vue?vue&type=script&lang=js"
export * from "./OtTable.vue?vue&type=script&lang=js"
import style0 from "./OtTable.vue?vue&type=style&index=0&id=ee7b3bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7b3bcc",
  null
  
)

export default component.exports